import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {HttpStatusCode, LoginService} from "@serengeti/serengeti-common";
import {TranslateService} from "@ngx-translate/core";
import {NotificationService} from "@serengeti/serengeti-notification";
import {ToasterService} from "angular2-toaster";
import {CodeService} from "@serengeti/serengeti-code";
import {OauthService} from "../../../oauth/service/oauth.service";
import {GuestUserService} from "@serengeti/serengeti-user";
import {AppConfigService} from "../../../app-config.service";
import {HistoryService} from "@serengeti/serengeti-resource";
import {MenuService} from "@serengeti/serengeti-menu";
import {environment} from 'src/environments/environment';

@Component({
  selector: 'app-member-signin-sso',
  templateUrl: './sso.component.html',
  styleUrls: ['./sso.component.css']
})
export class SsoComponent implements OnInit {

  env = environment;
  loading = false;
  returnUrl: string;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private translateService: TranslateService,
    private loginService: LoginService,
    private notificationService: NotificationService,
    private toasterService: ToasterService,
    private codeService: CodeService,
    private oauthService : OauthService,
    // private authService: AuthService,
    private guestUserService: GuestUserService,
    private appConfigService: AppConfigService,
    private historyService: HistoryService,
    private menuService: MenuService,
    private commonLoginService: LoginService
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const code = params['code'];
      const redirectUri = `${window.location.protocol}//${window.location.host}/ssosignin`;
      console.log(redirectUri);

      if (code) {
        // 서버에 액세스 토큰을 요청
        this.commonLoginService.ssoLogin(code, redirectUri).subscribe((res) => {
          if (res.status === 'login') {
            this.postLogin(res, false);
          }
        }, (error: any) => {
          this.postLoginError(error);
        });
      }
    });

    this.returnUrl = "/";
  }

  postLogin(user: any, oauthCreate: boolean) {
    this.codeService.find('SystemProfile', this.env.profile).subscribe((profileContent: any) => {
      try {
        this.env.content = JSON.parse(profileContent.detailInfo);
        this.loginService.setScreenConfig('login', 'profile', this.env.content);
        this.loginService.setScreenConfig('toaster', 'toaster', 'Subscribe');
      } catch (error) {
        console.log(error);
        console.log(profileContent.detailInfo);
      }
      this.notificationService.connect(user.loginId);
      if (oauthCreate) {
        this.translateService.get(['home.signin.alert.oauth-create']).subscribe((messages: string) => {
          alert(messages['home.signin.alert.oauth-create']);
        });
      }
      this.historyService.count().subscribe(count=> {
        this.appConfigService.numberOfNotification = count;
      });
      this.menuService.roots().subscribe(menus => {
        this.appConfigService.menus = menus;
      });
      const redirectUrl = localStorage.getItem('redirectUrl') || "/main";
      localStorage.setItem('redirectUrl',"");
      this.router.navigateByUrl(redirectUrl);
    }, () => {
      this.router.navigateByUrl("/");
    });
  }

  postLoginError(error: any) {
    switch (error.status) {
      case HttpStatusCode.LOCKED:
        this.translateService.get(['home.signin.alert.locked','home.signin.title']).subscribe((messages: string) => {
          this.toasterService.pop('error', messages['home.signin.title'], messages['home.signin.alert.locked']);
        });
        break;

      case HttpStatusCode.UNAVAILABLE_FOR_LEGAL_REASONS:
        this.translateService.get(['home.signin.alert.deleted','home.signin.title']).subscribe((messages: string) => {
          this.toasterService.pop('error', messages['home.signin.title'], messages['home.signin.alert.deleted']);
        });
        break;

      default:
        this.translateService.get(['home.signin.alert.failed','home.signin.title']).subscribe((messages: string) => {
          this.toasterService.pop('major', messages['home.signin.title'], messages['home.signin.alert.failed']);
        });
        break;
    }
    this.loading = false;
  }

  public loginSucceed(res): void {
    this.loading = true;
    if (res.status === 'login') {
      this.postLogin(res, false);
    } else {
      this.loading = false;
    }
  }
}
